"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.autoDownloadFile = exports.fetchReportFile = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const redux_observable_1 = require("redux-observable");
const Actions = require("../../actions/reports");
const ActionTypes = require("../../actionTypes/reports/file");
const ListActionTypes = require("../../actionTypes/reports/list");
const ErrorHandling = require("../../utils/errorHandling");
const reporting_1 = require("../../utils/reporting");
const fetchReportFile = (action$, _store, { ajax, getToken, baseUrl }) => {
    const ajaxOptions = (uuid) => ({
        method: 'GET',
        url: `${baseUrl}api/reports/${uuid}/download`,
        responseType: 'blob',
        headers: {
            Authorization: getToken()
        }
    });
    const ajaxCall = (uuid) => ajax(ajaxOptions(uuid)).pipe((0, operators_1.map)((response) => Actions.fetchReportFileSuccess(response.response)), (0, operators_1.catchError)((error) => {
        const responseError = ErrorHandling.parseAjaxErrorResponse(error);
        return (0, rxjs_1.of)(Actions.fetchReportFileFailure(responseError));
    }));
    return action$.pipe((0, redux_observable_1.ofType)(ActionTypes.FETCH_REPORT_FILE_REQUEST), (0, operators_1.map)((action) => action), (0, operators_1.switchMap)(({ payload }) => ajaxCall(payload.uuid)));
};
exports.fetchReportFile = fetchReportFile;
const mapAction = (report) => report ? (0, rxjs_1.of)(Actions.fetchReportFileRequest(report.uuid, report.name)) : rxjs_1.EMPTY;
const autoDownloadFile = (action$, store) => action$.pipe((0, redux_observable_1.ofType)(ListActionTypes.UPDATE_REPORT_STATUS), (0, operators_1.filter)(reporting_1.filterCompletedReports), (0, operators_1.map)((0, reporting_1.resolveReport)(store)), (0, operators_1.mergeMap)(mapAction));
exports.autoDownloadFile = autoDownloadFile;
//# sourceMappingURL=file.js.map